
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1160 850","fill":"none","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMinYMin slice","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".1","clip-path":"url(#svg-graphic-1__clip0_3642_131792)"}},[_c('path',{attrs:{"d":"M299 588C133.889 588 0 454.111 0 289S133.889-10 299-10s299 133.889 299 299","fill":"#7598C1"}}),_c('path',{attrs:{"d":"M598 289c0 165.111-133.889 299-299 299V289h299z","fill":"#B8C9DE"}}),_c('path',{attrs:{"d":"M598 289c0-165.111 133.842-299 299-299 165.16 0 299 133.889 299 299s-133.89 299-299 299","fill":"#fff"}}),_c('path',{attrs:{"d":"M897 588c-165.111 0-299-133.889-299-299h299v299z","fill":"#AFC5DA"}}),_c('path',{attrs:{"d":"M897 588c165.11 0 299 133.889 299 299 0 165.11-133.89 299-299 299-165.111 0-299-133.89-299-299","fill":"#B8C9DE"}}),_c('path',{attrs:{"d":"M598 887c0-165.111 133.889-299 299-299v299H598z","fill":"#7598C1"}}),_c('path',{attrs:{"d":"M598 887c0 165.11-133.842 299-299 299S0 1052.11 0 887c0-165.111 133.842-299 299-299","fill":"#106CA4"}}),_c('path',{attrs:{"d":"M299 588c165.111 0 299 133.842 299 299H299V588z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"svg-graphic-1__clip0_3642_131792"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 -10)","d":"M0 0h1196v1196H0z"}})])])])
          )
        }
      }
    